"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _locale = require("../locale");
var _components = _interopRequireDefault(require("../previews/components"));
var _tokenCard = _interopRequireDefault(require("../token-panel/token-card"));
var _getDesignToken = _interopRequireDefault(require("../utils/getDesignToken"));
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _statistic = require("../utils/statistic");
var _ComponentCard = _interopRequireDefault(require("./ComponentCard"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultAlgorithm = _antd.theme.defaultAlgorithm;
var useStyle = (0, _makeStyle.default)('ComponentTokenDrawer', function (token) {
  return {
    '.previewer-component-token-drawer': (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "&".concat(token.rootCls, "-drawer ").concat(token.rootCls, "-drawer-body"), {
      padding: '0 !important'
    }), '.previewer-component-drawer-subtitle', {
      fontWeight: token.fontWeightStrong,
      marginBottom: token.marginSM,
      marginInlineStart: token.marginXS,
      color: token.colorText
    }), '.previewer-component-token-drawer-theme', {
      fontWeight: 'normal',
      marginInlineStart: 8,
      borderRadius: 4,
      backgroundColor: token.colorInfoBg,
      color: token.colorPrimary,
      borderColor: token.colorInfoBg
    })
  };
});
var useComponentFullDemosStyle = (0, _makeStyle.default)('ComponentFullDemos', function (token) {
  return {
    '.previewer-component-full-demos': {
      flex: 1,
      overflow: 'auto',
      padding: 24,
      backgroundColor: token.colorBgLayout,
      '> *:not(:last-child)': {
        marginBottom: 12
      }
    }
  };
});
var ComponentFullDemos = function ComponentFullDemos(_ref) {
  var demos = _ref.demos;
  var _useComponentFullDemo = useComponentFullDemosStyle(),
    _useComponentFullDemo2 = (0, _slicedToArray2.default)(_useComponentFullDemo, 2),
    hashId = _useComponentFullDemo2[1];
  var locale = (0, _locale.useLocale)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('previewer-component-full-demos', hashId),
    style: {}
  }, demos === null || demos === void 0 ? void 0 : demos.map(function (demo) {
    var _demo$tokens, _demo$tokens2, _demo$tokens3;
    return /*#__PURE__*/_react.default.createElement(_ComponentCard.default, {
      key: demo.key,
      title: /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
        title: (_demo$tokens = demo.tokens) === null || _demo$tokens === void 0 ? void 0 : _demo$tokens.join(', ')
      }, /*#__PURE__*/_react.default.createElement("span", null, locale.demo.relatedTokens, ": ", (_demo$tokens2 = demo.tokens) === null || _demo$tokens2 === void 0 ? void 0 : _demo$tokens2.join(', '), (((_demo$tokens3 = demo.tokens) === null || _demo$tokens3 === void 0 ? void 0 : _demo$tokens3.length) || 0) > 2 ? '...' : ''))
    }, demo.demo);
  }));
};
var ComponentTokenDrawer = function ComponentTokenDrawer(_ref2) {
  var visible = _ref2.visible,
    _ref2$component = _ref2.component,
    component = _ref2$component === void 0 ? 'Button' : _ref2$component,
    onClose = _ref2.onClose,
    theme = _ref2.theme;
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    hashId = _useStyle2[1];
  var _ref3 = (0, _statistic.getComponentToken)(component) || {
      global: []
    },
    componentToken = _ref3.component,
    aliasTokenNames = _ref3.global;
  var componentTokenData = (0, _react.useMemo)(function () {
    return Object.keys(componentToken !== null && componentToken !== void 0 ? componentToken : {});
  }, [componentToken]);
  var aliasTokenData = (0, _react.useMemo)(function () {
    return aliasTokenNames.sort();
  }, [aliasTokenNames]);
  var handleComponentTokenChange = function handleComponentTokenChange(token, value) {
    var _theme$onThemeChange, _theme$config$compone;
    (_theme$onThemeChange = theme.onThemeChange) === null || _theme$onThemeChange === void 0 || _theme$onThemeChange.call(theme, _objectSpread(_objectSpread({}, theme.config), {}, {
      components: _objectSpread(_objectSpread({}, theme.config.components), {}, (0, _defineProperty2.default)({}, component, _objectSpread(_objectSpread({}, (_theme$config$compone = theme.config.components) === null || _theme$config$compone === void 0 ? void 0 : _theme$config$compone[component]), {}, (0, _defineProperty2.default)({}, token, value))))
    }), ['components', component, token]);
  };
  return /*#__PURE__*/_react.default.createElement(_antd.Drawer, {
    open: visible,
    title: /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, "".concat(component, " \u7EC4\u4EF6 Token")), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
      className: "previewer-component-token-drawer-theme"
    }, theme.name)),
    onClose: onClose,
    width: 1200,
    className: (0, _classnames.default)('previewer-component-token-drawer', hashId)
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: theme.config
  }, /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: theme.config
  }, /*#__PURE__*/_react.default.createElement(ComponentFullDemos, {
    demos: _components.default[component]
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: '0 0 400px',
      overflow: 'auto',
      padding: 24
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "previewer-component-drawer-subtitle"
  }, "Related Tokens / \u76F8\u5173 token"), /*#__PURE__*/_react.default.createElement(_tokenCard.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.BuildOutlined, null),
    hideUsageCount: true,
    defaultOpen: true,
    title: "Component Token",
    tokenArr: componentTokenData,
    tokenPath: ['components', component],
    themes: [theme],
    fallback: function fallback() {
      return componentToken;
    },
    onTokenChange: function onTokenChange(_, tokenName, value) {
      return handleComponentTokenChange(tokenName, value);
    },
    placeholder: /*#__PURE__*/_react.default.createElement(_antd.Empty, {
      image: _antd.Empty.PRESENTED_IMAGE_SIMPLE,
      description: "\u6682\u65E0\u76F8\u5173 Component Token",
      style: {
        marginBlock: 0,
        paddingBlock: 32
      }
    })
  }), /*#__PURE__*/_react.default.createElement(_tokenCard.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.CarOutlined, null),
    hideUsageCount: true,
    themes: [theme],
    defaultOpen: true,
    title: "Alias Token",
    tokenArr: aliasTokenData,
    tokenPath: ['components', component],
    fallback: function fallback(themeConfig) {
      return (0, _getDesignToken.default)(themeConfig);
    },
    onTokenChange: function onTokenChange(_, tokenName, value) {
      return handleComponentTokenChange(tokenName, value);
    },
    placeholder: /*#__PURE__*/_react.default.createElement(_antd.Empty, {
      image: _antd.Empty.PRESENTED_IMAGE_SIMPLE,
      description: "\u6682\u65E0\u76F8\u5173 Alias Token",
      style: {
        marginBlock: 0,
        paddingBlock: 32
      }
    })
  }))));
};
var _default = exports.default = function _default(_ref4) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(_ref4), _ref4));
  return /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: {
      algorithm: defaultAlgorithm
    }
  }, /*#__PURE__*/_react.default.createElement(ComponentTokenDrawer, props));
};